import { render, staticRenderFns } from "./RecommendEventPopover.vue?vue&type=template&id=675a6ef3"
import script from "./RecommendEventPopover.vue?vue&type=script&lang=js"
export * from "./RecommendEventPopover.vue?vue&type=script&lang=js"
import style0 from "./RecommendEventPopover.vue?vue&type=style&index=0&id=675a6ef3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports